import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { LogoNames } from 'src/app/shared/enums/logoNames.enum';
import { KTUtil } from '../../../../../assets/js/components/util';
import KTLayoutHeader from '../../../../../assets/js/layout/base/header';
import KTLayoutHeaderMenu from '../../../../../assets/js/layout/base/header-menu';
import { LayoutService } from '../../../../RefModules/_metronic/core';

@Component({
    selector: 'app-informate-header',
    templateUrl: './informate-header.component.html',
    styleUrls: ['./informate-header.component.scss'],
})
export class InformateHeaderComponent implements OnInit {
    @ViewChild('ktHeaderMenu', { static: true }) ktHeaderMenu: ElementRef;

    JA = LogoNames.JA;
    headerContainerCSSClasses: string;
    headerMenuSelfDisplay: boolean;
    headerMenuSelfStatic: boolean;
    asideSelfDisplay: boolean;
    headerLogo: string;
    headerSelfTheme: string;
    headerMenuCSSClasses;
    headerMenuHTMLAttributes: any = {};
    routerLoaderTimout: any;
    ulCSSClasses: string;
    rootArrowEnabled: boolean;
    location: Location;
    headerMenuDesktopToggle: string;
    display = 'none';
    loader$: Observable<number>;
    isStandardFlange: boolean;
    isCustomFlange: boolean;
    isClamp: boolean;
    isEngineeredJointVisible: boolean;
    isMatrixVisible: boolean;
    isIceDatabaseVisible: boolean = false;

    private loaderSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

    constructor(
        private layout: LayoutService,
        public router: Router,
        private userUtilityService: UserUtilityService
    ) {
        this.loader$ = this.loaderSubject;
        // page progress bar percentage
        const routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                // set page progress bar loading to start on NavigationStart event router
                this.loaderSubject.next(10);
            }
            if (event instanceof RouteConfigLoadStart) {
                this.loaderSubject.next(65);
            }
            if (event instanceof RouteConfigLoadEnd) {
                this.loaderSubject.next(90);
            }
            if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
                // set page progress bar loading to end on NavigationEnd event router
                this.loaderSubject.next(100);
                if (this.routerLoaderTimout) {
                    clearTimeout(this.routerLoaderTimout);
                }
                this.routerLoaderTimout = setTimeout(() => {
                    this.loaderSubject.next(0);
                }, 300);
            }
        });
        this.unsubscribe.push(routerSubscription);
        this.isStandardFlange = false;
        this.isCustomFlange = false;
        this.isClamp = false;
        this.isEngineeredJointVisible = false;
        this.isMatrixVisible = false;
    }

    async ngOnInit(): Promise<void> {
        // * checking access level
        this.isStandardFlange = await this.userUtilityService.checkUserPermissionDataAndRoute('standardflange/:isRedirect', userActions.View);
        this.isCustomFlange = await this.userUtilityService.checkUserPermissionDataAndRoute('customflange/:isRedirect', userActions.View);
        this.isClamp = await this.userUtilityService.checkUserPermissionDataAndRoute('clamp/:isRedirect', userActions.View);
        this.isEngineeredJointVisible = await this.userUtilityService.checkUserPermissionDataAndRoute('engineeredjoint/:isRedirect', userActions.View);
        this.isMatrixVisible = await this.userUtilityService.checkUserPermissionDataAndRoute('matrix', userActions.View);
        this.isIceDatabaseVisible = this.userUtilityService.getUserData()?.isSysAdmin ?? false;

        this.headerContainerCSSClasses = this.layout.getStringCSSClasses('header_container');
        this.headerMenuSelfDisplay = this.layout.getProp('header.menu.self.display');
        this.asideSelfDisplay = this.layout.getProp('aside.self.display');
        this.headerMenuSelfStatic = this.layout.getProp('header.menu.self.static');
        this.headerSelfTheme = this.layout.getProp('header.self.theme') || '';
        this.headerLogo = this.getLogoURL();
        this.headerMenuCSSClasses = this.layout.getStringCSSClasses('header_menu');
        this.headerMenuHTMLAttributes = this.layout.getHTMLAttributes('header_menu');
        this.ulCSSClasses = this.layout.getStringCSSClasses('header_menu_nav');
        this.rootArrowEnabled = this.layout.getProp('header.menu.self.rootArrow');
        this.headerMenuDesktopToggle = this.layout.getProp('header.menu.desktop.toggle');
    }

    ngAfterViewInit(): void {
        if (this.ktHeaderMenu) {
            for (const key in this.headerMenuHTMLAttributes) {
                if (this.headerMenuHTMLAttributes.hasOwnProperty(key)) {
                    this.ktHeaderMenu.nativeElement.attributes[key] = this.headerMenuHTMLAttributes[key];
                }
            }
        }

        KTUtil.ready(() => {
            // Init Desktop & Mobile Headers
            KTLayoutHeader.init('kt_header', 'kt_header_mobile');
            // Init Header Menu
            KTLayoutHeaderMenu.init('kt_header_menu', 'kt_header_menu_wrapper');
        });
    }

    private getLogoURL(): string {
        let result = 'logo-light.png';

        if (this.headerSelfTheme && this.headerSelfTheme === 'light') {
            result = 'logo-dark.png';
        }

        if (this.headerSelfTheme && this.headerSelfTheme === 'dark') {
            result = 'logo-dark.png';
        }

        return `./assets/media/logos/${result}`;
    }
}
